import React, { Component } from "react";
import {
  Collapse,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  NavItem,
} from "reactstrap";
import { Dropdown, NavDropdown } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import "../styles/NavMenu.css";
import { config } from "../Utils/config";

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor(props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true,
    };
  }

  toggleNavbar() {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  }

  render() {
    const user = this.props.user;
    const isOwner = user && user.roles && (user.roles === "Owner" || (Array.isArray(user.roles) && user.roles.includes("Owner")));
    const isAdmin = user && user.roles && (user.roles === "Administrador" || (Array.isArray(user.roles) && user.roles.includes("Administrador")));

    return (
      <header>
        <Navbar
          className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3"
          container
          light
        >
          <NavbarBrand tag={Link} to="/">
            {isOwner ? (
              <>
                Facturación Electronica :: {config.VERSION} {config.ENTORNO}
              </>
            ) : (
              <>
                Facturación Electronica :: {user?.tenantName || config.NOMBRE_EMPRESA} :: {config.VERSION} {config.ENTORNO}
              </>
            )}
          </NavbarBrand>
          <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
          <Collapse
            className="d-sm-inline-flex flex-sm-row-reverse"
            isOpen={!this.state.collapsed}
            navbar
          >
            <ul className="navbar-nav flex-grow">
              {!user ? (
                <></>
              ) : (
                <>
                  <NavItem>
                    <Link to="/home" className="nav-link">
                      Inicio
                    </Link>
                  </NavItem>

                  {(isOwner || isAdmin) && (
                    <NavDropdown title="Configuración" id="config-nav-dropdown">
                      {/* Owner: Solo gestiona plataforma */}
                      {isOwner && (
                        <>
                          <NavDropdown.Item as={Link} to="/configuracion/tenants">
                            Tenants
                          </NavDropdown.Item>
                          <NavDropdown.Item as={Link} to="/configuracion/usuarios">
                            Usuarios
                          </NavDropdown.Item>
                        </>
                      )}
                      
                      {/* Admin: Gestiona su tenant */}
                      {isAdmin && !isOwner && (
                        <>
                          <NavDropdown.Item as={Link} to="/configuracion/usuarios">
                            Usuarios
                          </NavDropdown.Item>
                          
                          <NavDropdown.Divider />
                          
                          <NavDropdown.Item as={Link} to="/configuracion/establecimientos">
                            Establecimientos
                          </NavDropdown.Item>
                          
                          <NavDropdown.Item as={Link} to="/configuracion/puntos-expedicion">
                            Puntos de Expedición
                          </NavDropdown.Item>
                          
                          <NavDropdown.Item as={Link} to="/configuracion/timbrados">
                            Timbrados
                          </NavDropdown.Item>
                          
                          <NavDropdown.Item as={Link} to="/configuracion/certificados">
                            Certificados Digitales
                          </NavDropdown.Item>
                          
                          <NavDropdown.Divider />
                          
                          <NavDropdown.Item as={Link} to="/configuracion/consulta-ruc">
                            Consulta RUC
                          </NavDropdown.Item>
                        </>
                      )}
                    </NavDropdown>
                  )}

                  <NavItem>
                    <div className="nav-user-data">
                      <p>{user.fullName}</p>
                      <Button
                        variant="secondary"
                        onClick={() => this.props.logout()}
                      >
                        Cerrar Sessión
                      </Button>
                    </div>
                  </NavItem>
                </>
              )}
            </ul>
          </Collapse>
        </Navbar>
      </header>
    );
  }
}
